import React from "react";
import Typography from "@mui/material/Typography";
import {formInstructionStyle} from "./formInstructionStyle";

interface CustomTypographyProps {
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "button"
    | "caption"
    | "overline";
  outlet?: React.ReactNode;
}

const FormInstructions: React.FC<CustomTypographyProps> = ({
  variant,
  outlet,
  ...props
}) => {
  return (
    <Typography
      component="p"
      variant={variant}
      {...props}
      sx={formInstructionStyle.pleaseSignInText}>
      {outlet}
    </Typography>
  );
};

export default FormInstructions;
